import React, { useEffect } from "react";
import "./attendance.css";
import AdminSideBar from "../admin-page/AdminSideBar";
import { useDispatch, useSelector } from "react-redux";
import {
  getTodayAttendanceApi,
  userCheckInApi,
  userCheckOutApi,
  getAttendanceByDateApi,
} from "../../redux/apiCalls/attendanceApiCall";

function Attendance() {
  const dispatch = useDispatch();

  const { user } = useSelector((state) => state.auth);
  const { userCheckIn, userCheckOut, yesterdayAttendance } = useSelector(
    (state) => state.attendance
  );

  const todayDate = new Date();
  const todayFormatted = todayDate.toLocaleDateString("en-GB", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const yesterdayDate = new Date();
  yesterdayDate.setDate(yesterdayDate.getDate() - 1);

  const yesterdayApiDate = yesterdayDate.toISOString().split("T")[0];
  const yesterdayFormatted = yesterdayDate.toLocaleDateString("en-GB", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  useEffect(() => {
    dispatch(getTodayAttendanceApi());
    dispatch(getAttendanceByDateApi(yesterdayApiDate));
  }, [dispatch, yesterdayApiDate]);

  const handleCheckIn = () => {
    dispatch(userCheckInApi());
  };

  const handleCheckOut = () => {
    dispatch(userCheckOutApi());
  };

  return (
    <main className="admin-page">
      <div className="admin-layout">
        <AdminSideBar />

        <section className="admin-main">
          <header className="admin-main-header">
            <h2 className="admin-main-title">Attendance</h2>
            <p className="admin-main-subtitle">
              Daily attendance record.
            </p>
          </header>

          <div className="admin-main-body attendance-stack">
            {/* ===== TODAY CARD ===== */}
            <div className="attendance-card">
              <div className="attendance-user">
                <div className="attendance-avatar">
                  <img src={user?.profilePicture?.url} alt="User profile" />
                </div>
                <div className="attendance-user-info">
                  <h3 className="attendance-username">{user?.userName}</h3>
                  <p className="attendance-email">{user?.email}</p>
                </div>
              </div>

              <div className="attendance-date">
                <span>Today</span>
                <strong>{todayFormatted}</strong>
              </div>

              <div className="attendance-actions">
                {/* Check In */}
                <div className="attendance-time-box">
                  <label>Check In</label>
                  <div className="attendance-time">
                    <span>
                      {userCheckIn?.attendance?.checkInTime
                        ? new Date(
                            userCheckIn.attendance.checkInTime
                          ).toLocaleTimeString()
                        : "-- : --"}
                    </span>
                    <button
                      onClick={handleCheckIn}
                      disabled={!!userCheckIn?.attendance?.checkInTime}
                      className="attendance-btn attendance-btn-in"
                    >
                      Check In
                    </button>
                  </div>
                </div>

                {/* Check Out */}
                <div className="attendance-time-box">
                  <label>Check Out</label>
                  <div className="attendance-time">
                    <span>
                      {userCheckOut?.attendance?.checkOutTime
                        ? new Date(
                            userCheckOut.attendance.checkOutTime
                          ).toLocaleTimeString()
                        : "-- : --"}
                    </span>
                    <button
                      onClick={handleCheckOut}
                      disabled={!!userCheckOut?.attendance?.checkOutTime}
                      className="attendance-btn attendance-btn-out"
                    >
                      Check Out
                    </button>
                  </div>
                </div>

                {/* Total Hours */}
                {/* <div className="attendance-time-box">
                  <label>Total Hours</label>
                  <div className="attendance-time">
                    <span>
                      {userCheckOut?.attendance?.totalHoursDisplay ?? "-- : --"}
                    </span>
                  </div>
                </div> */}
              </div>
            </div>

            {/* ===== YESTERDAY SIMPLE DISPLAY ===== */}
            <div className="attendance-yesterday-simple">
              <strong>Yesterday: {yesterdayFormatted}</strong>
              <div className="attendance-yesterday-lines">
                <div>
                  <span className="attendance-label">Check In:</span>
                  <span className="attendance-value">
                    {yesterdayAttendance?.checkInTime
                      ? new Date(
                          yesterdayAttendance.checkInTime
                        ).toLocaleTimeString()
                      : "-- : --"}
                  </span>
                </div>
                <div>
                  <span className="attendance-label">Check Out:</span>
                  <span className="attendance-value">
                    {yesterdayAttendance?.checkOutTime
                      ? new Date(
                          yesterdayAttendance.checkOutTime
                        ).toLocaleTimeString()
                      : "-- : --"}
                  </span>
                </div>
                <div>
                  <span className="attendance-label">Total Hours:</span>
                  <span className="attendance-value">
                    {yesterdayAttendance?.totalHoursDisplay ?? "-- : --"}
                  </span>
                </div>
              </div>
            </div>
            {/* ===== END ===== */}
          </div>
        </section>
      </div>
    </main>
  );
}

export default Attendance;
